let propertyAreaNode, switchViewNodes, container;
const realpressHeaderMapLayout = () => {
	propertyAreaNode = document.querySelector( '#realpress-hm-property-area' );
	if ( ! propertyAreaNode ) {
		return;
	}
	switchViewNodes = propertyAreaNode.querySelectorAll( '.realpress-item-switch-view li' );

	if ( ! switchViewNodes ) {
		return;
	}

	container = propertyAreaNode.querySelector( '.realpress-property-container' );
	let col = JSON.parse( localStorage.getItem( 'realpress_swm_layout_active' ) );
	if ( col == null ) {
		col = switchViewNodes[ 0 ].getAttribute( 'data-grid-col' );
		switchViewNodes[ 0 ].classList.add( 'active' );
		localStorage.setItem( 'realpress_hm_layout_active', JSON.stringify( col ) );
	} else {
		propertyAreaNode.querySelector( '.realpress-item-switch-view li[data-grid-col="' + col + '"]' ).classList.add( 'active' );
		container.setAttribute( 'data-grid-col', col );
	}
	switchViewMode();
};

const switchViewMode = () => {
	for ( let i = 0; i < switchViewNodes.length; i++ ) {
		switchViewNodes[ i ].addEventListener( 'click', function() {
			const activeViewNode = propertyAreaNode.querySelector( '.realpress-item-switch-view li.active' );
			const activeView = activeViewNode.getAttribute( 'class' );
			const view = this.getAttribute( 'class' );
			if ( view !== activeView ) {
				activeViewNode.classList.remove( 'active' );
				this.classList.add( 'active' );
				const col = this.getAttribute( 'data-grid-col' );
				container.setAttribute( 'data-grid-col', col );
				localStorage.setItem( 'realpress_hm_layout_active', JSON.stringify( col ) );
			}
		} );
	}
};

export default realpressHeaderMapLayout;
